import { useQuery } from "@tanstack/react-query";
import SubLabel from "components/Atoms/Sublabel";
import { GooglePlaceInput } from "components/ValidatedFields/GooglePlaceInput";
import React from "react";
import { Loader } from "semantic-ui-react";
import Removable, { RemovableLabel, type RemovableProps } from "./Removable";
import { v4 as uuidv4 } from "uuid";

const RemovableTrainStation = (props: RemovableProps<server.dto.TrainStation>) => {
  const [selectedPlace, setSelectedPlace] = React.useState<server.dto.GooglePlaceAutocomplete>(null);

  const trainQuery = useQuery({
    queryKey: ["trainstation", selectedPlace?.placeId],
    queryFn: async () => window.CoreApi.GooglePlace.GetTrainStation({ placeId: selectedPlace.placeId, sessionToken: uuidv4(), calledFrom: "train" }).then(r => r.data.data), // We don't want a different uuidv4 every time we call this method. This should be a sessionToken!
    enabled: selectedPlace != null,
    onSuccess: res => {
      props.onChange(res);
      setSelectedPlace(null);
    }
  });

  const isTrainQueryLoading = trainQuery.isLoading && selectedPlace != null;

  return <Removable<server.dto.TrainStation>
    renderRemovableLabel={RemovableTrainStationLabel}
    {...props}
  >
    {isTrainQueryLoading
      ? <Loader active inline size="small" />
      : <GooglePlaceInput
        onPlaceSelected={v => setSelectedPlace({
          placeId: v.id,
          mainText: v.name,
          secondaryText: v.address
        })}
        hasError={props.error}
        types={["transit_station"]}
      />}
  </Removable>;
};

const RemovableTrainStationLabel = (props: RemovableProps<server.dto.TrainStation>) => {
  return <RemovableLabel {...props}>
    <div>
      {props.value.name}
      <SubLabel small>
        {props.value.address.formatted.join(", ")}
      </SubLabel>
    </div>
  </RemovableLabel>;
};

export default RemovableTrainStation;